import { fetchData } from '../utils/netUtils';
import {
  checkifEmptyObject,
  removeEmptyKeys
} from '../utils/objectUtils';
import { resolveCurrentEnvironment } from '../utils/configUtils';

const FILTERS_MAPPER = {
};

const unitySectionService = {

  getSections: async (tokenData, {
    ids,
    inMenuOnly,
    onlyPublic,
    page = 1,
    pageSize = 10
  }) => {
    const filters = {
      ids,
      inMenuOnly,
      page,
      pageSize
    };
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/sections`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    const filtersToQs = removeEmptyKeys(filters);
    if (filtersToQs && !checkifEmptyObject(filtersToQs)) {
      let qs = Object.keys(filtersToQs).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(filters[key])
      }).join('&');

      URL += `?${qs}`;
    }

    return fetchData(URL, options);
  },

  getSectionComponents: async (tokenData, sectionID, { active }) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/sections/${sectionID}/components`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    if (active) {
      URL += `?active=${active}`;
    }

    return fetchData(URL, options);
  },

  getSectionComponentItems: async (tokenData, sectionID, widgetID, filters={}) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/sections/${sectionID}/components/${widgetID}/items`;

    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    const filtersToQs = removeEmptyKeys(filters);
    if (filtersToQs && !checkifEmptyObject(filtersToQs)) {

      let qs =  Object.keys(filtersToQs).map((key) => {
        const qsKey = FILTERS_MAPPER[key] || key;

        if (typeof(filters[key]) === 'boolean') {
          return encodeURIComponent(qsKey);
        }
        return encodeURIComponent(qsKey) + '=' + encodeURIComponent(filters[key])
      }).join('&');

      URL += `?${qs}`;
    }

    return fetchData(URL, options);
  }
};

export default unitySectionService;
